import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {Card} from '../../card/Card';
import StarRating from './StarRating';
import ReaderReviewsEventTypes from '../../../data/types/ReaderReviewsEventTypes';
import TrackedLink from '../generic/TrackedLink';
import ResultsModal from '../generic/ResultsModal';
import CardTitle from '../../card/CardTitle';

import { OverviewFooter } from "../../card/OverviewFooter";
import GoodReadsImage from './goodreads-badge-read-reviews.png';
import '../../card/cardContent.less';
import './readerReviews.less';

class ReaderReviews extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            isModalOpen: false,
            iFrameStyle: {visibility: 'hidden'}
        };

        this.openModal = this.openModal.bind(this);
        this.dataLoaded = this.dataLoaded.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({
            isModalOpen: true,
            isLoading: true,
            iFrameStyle: {visibility: 'hidden'}
        });
    }

    closeModal() {
        this.setState({
            isModalOpen: false,
            isLoading: false,
            iFrameStyle: {visibility: 'hidden'}
        })
    }

    dataLoaded() {
        this.setState({
            isLoading: false,
            iFrameStyle: {visibility: 'visible'}
        });
    }

    render() {
        let modalTitle = 'Goodreads reviews for ' + this.props.fullTitle;

        if(this.props.cardModel && this.props.cardModel.isInGoodReads) {
            return (
                <Card>
					<CardTitle title="Reader Reviews" />
					<div className="reviews-content">
						<div className="reviews-stars-container">
							<StarRating averageRating={this.props.cardModel.averageRating}/>
						</div>
						<TrackedLink featureType={ReaderReviewsEventTypes.GOODREADSREVIEW_RATING_CLICKED} destId={this.props.cardModel.isbn}>
							<div className="clickable reviews-link">
								<span className="reviews-goodreads-link" onClick={this.openModal}>
									{`${this.props.cardModel.reviewsCount} ${this.props.uiVersionFlag? "GoodReads reviews" : "reviews"}`} 
								</span>
							</div>
						</TrackedLink>
						<TrackedLink featureType={ReaderReviewsEventTypes.GOODREADSREVIEW_LOGO_CLICKED} destId={this.props.cardModel.isbn}>
							<button type="button" className="reviews-goodreads-link" onClick={this.openModal}>
								<img src={GoodReadsImage} alt="Goodreads badge read reviews"/>
							</button>
						</TrackedLink>
						<ResultsModal modalTitle={modalTitle} isLoading={this.state.isLoading} isOpen={this.state.isModalOpen} close={this.closeModal}>
							<iframe title='GoodReads' src={this.props.cardModel.goodReadsUrl} height='100%' width='100%' style={this.state.iFrameStyle}
								onLoad={this.dataLoaded}/>
						</ResultsModal>
					</div>
					{this.props.uiVersionFlag? null : <OverviewFooter />}
                </Card>
            );
        } else {
            return null;
        }
    }
}

ReaderReviews.propTypes = {
    cardModel: PropTypes.object,
	fullTitle: PropTypes.string.isRequired,
	onNullRender: PropTypes.func
};

export default ReaderReviews;


// WEBPACK FOOTER //
// ./src/react/views/readerReviews/ReaderReviews.jsx